import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { CalificacionConductor } from '../clases/calificacion-conductor';

@Injectable({
  providedIn: 'root'
})
export class EnviosService {

  constructor(private _http: HttpClient) { }

  ListarServicioCurso(idServicio: any){
    let url = environment.URL_BASE + 'servicioAuthorization/curso2?idServicio=' + idServicio
    return this._http.get(url)
  }

  ListarEnvios(idCliente: string, todos: boolean) {
    let url = environment.URL_BASE + 'servicioAuthorization/curso' + '?idCliente=' + idCliente + '&todos=' + todos
    return this._http.get(url)
  }

  EnviosAnteriores(obj: any) {
    let url = environment.URL_BASE + 'servicioAuthorization/historico' //+ '?idCliente=' + obj.idCliente + '&fechaInicio=' + obj.fechaInicio + '&fechaFin='+ obj.fechaFin;
    //return this._http.get(url)
    return this._http.post(url,obj)
  }

  EnviosAnterioresPost(obj: any) {
    let url = environment.URL_BASE + 'servicioAuthorization/historico';
    return this._http.post(url,obj )
  }


  consultarPosicionConductor(idServicio: any){
    let url = environment.URL_BASE + 'servicioAuthorization/curso' +  "?idServicio=" + idServicio
    return this._http.get(url)
  }

  motivoCancelacion(){
    let url = environment.URL_BASE + 'genericaAuthorization/get?id=21'
    return this._http.get(url)
  }

  calificarCondutor(obj: CalificacionConductor){
    let url = environment.URL_BASE + 'CalificacionAuthorization/ActualizarCalificacion';
    return this._http.post(url, obj);
   }
  
   listarCalificacion(obj: any){
    let url = environment.URL_BASE + 'CalificacionAuthorization/ObtenerCalificacion';
    return this._http.post(url, obj);
   }
}
